export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DashboardAdmin.vue?vue&type=style&index=0&id=196eabab&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/DashboardAdmin.vue?vue&type=style&index=0&id=196eabab&prod&scoped=true&lang=css&
// module id = 961
// module chunks = 0